import { createComponent } from '@carvana/vdp-components';

export const CommonWrapper = createComponent('div', {
  className: 'grid gap-16 p-32'
});

export const ModelWrapper = createComponent('div', {
  className: 'grid pb-32 gap-16'
});

export const TrimWrapper = createComponent('div', {
  className:
    'grid gap-16 border-solid border-0 border-grey-2 border-b-2 pt-32 pb-[35px] last:pb-0 last:border-0 first:pt-0'
});
